import React from "react";
import {formatCurrency} from "../../../../helpers";
import {Colors, Container, IconGoTo, Text} from "../../../../ui";
import {BundleAccountBreakdown} from "../../../declarations";
import {formatBundleProductLabel} from "../utils";

interface IBundleBreakdownRow {
  item: BundleAccountBreakdown;
  onItemClick?: (accountId: number) => void;
  showSubProduct?: boolean;
}

export const BundleBreakdownRow = ({item, onItemClick, showSubProduct}: IBundleBreakdownRow) => {
  return (
    <Container fullWidth row sx={{justifyContent: "space-between"}}>
      <Container sx={{alignItems: "flex-start", gap: "2px"}}>
        <Text size={14} variant="inter600" color={Colors.grey._700}>
          {showSubProduct ? formatBundleProductLabel(item) : item.product}
        </Text>
        <Text size={12} variant="inter400" color={Colors.grey._500}>
          {item.account_public_id}
        </Text>
      </Container>
      <Container
        row
        sx={{alignItems: "center", gap: "6px", flexShrink: 0, ...(onItemClick && {cursor: "pointer"})}}
        onClick={onItemClick ? () => onItemClick(item.account_id) : undefined}
      >
        <Container row sx={{gap: "4px"}}>
          <Text size={16} variant="interDisplay400" sx={{display: "inline"}} color={Colors.green._900}>
            {formatCurrency(item.amount_paid)}
          </Text>
          <Text size={16} variant="interDisplay400" sx={{display: "inline"}} color={Colors.grey._800}>
            {`/ ${formatCurrency(item.original_balance)}`}
          </Text>
        </Container>
        <IconGoTo width={16} height={16} />
      </Container>
    </Container>
  );
};
